import { cn } from "../lib/cn";

export interface BrandMarkProps {
  size?: number;
  className?: string;
  /** Set to false when a visible "Artisan" word sits next to the mark. */
  labelled?: boolean;
}

/** The hexagonal "A" mark, one colour (currentColor). */
export function BrandMark({ size = 28, className, labelled = true }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill="none"
      className={cn("shrink-0", className)}
      role={labelled ? "img" : undefined}
      aria-label={labelled ? "Artisan" : undefined}
      aria-hidden={labelled ? undefined : true}
    >
      <path
        d="M64 15L101 36V82L64 104L27 82V36L64 15Z"
        stroke="currentColor"
        strokeWidth={7}
        strokeLinejoin="round"
      />
      <path
        d="M43 87L64 39L85 87"
        stroke="currentColor"
        strokeWidth={8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M53 68H75" stroke="currentColor" strokeWidth={7} strokeLinecap="round" />
    </svg>
  );
}
